import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { parseAdobeCookie } from '@thd-olt-functional/utils/src/adobe/adobe';
import ExperienceContext from './ExperienceContext';

const ExperienceProvider = ({ value, children, disableLocalization = false }) => {
  const isServer = !((
    typeof window !== 'undefined'
    && window.document
    && window.document.createElement));

  const [store, setStore] = useState(null);
  const [adobeCookie, setAdobeCookie] = useState(null);
  const [mounted, setMounted] = useState(false);

  const cntx = {
    isServer,
    cookie: value.cookie,
    channel: value.channel,
    configService: value.configService,
    hosts: value.hosts,
    path: value.path,
    store: value.store,
    clientStore: value.clientStore,
    segment: value.segment,
    isDebugMode: typeof value.isDebugMode !== 'undefined'
      ? value.isDebugMode
      : false,
    isLocal: value.isLocal,
    customer: value.customer,
    localStoreZip: value.localStoreZip,
    deliveryZip: value.deliveryZip,
    isConsumerApp: value.isConsumerApp,
    mounted
  };

  useEffect(() => {
    const localize = typeof THD_LOCALIZER_AUTO_INIT !== 'undefined' && THD_LOCALIZER_AUTO_INIT?.Localizer?.localize;// eslint-disable-line
    if (localize && !disableLocalization) {
      localize().then((methods) => {
        const localStore = methods?.getLocalizedStore();
        if (localStore) {
          setStore({
            storeHours: localStore.storeHours,
            storeId: localStore.storeId,
            storeName: localStore.name,
            storeZip: localStore.zipcode
          });
        }
      });
    }

    if (!isServer && typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('experience-context.ready', cntx);
    }
  }, []);

  useEffect(() => {
    try {
      const cookieValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith('AMCV_F6421253512D2C100A490D45%40AdobeOrg'))
        .split('=')[1];

      const ADOBE_COOKIE = parseAdobeCookie(cookieValue);
      setAdobeCookie(ADOBE_COOKIE);
    } catch (error) {
      setAdobeCookie({});
    }
  }, []);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (store) {
    cntx.clientStore = store;
  }
  if (adobeCookie) {
    cntx.cookie.adobeCookie = adobeCookie;
  }

  return (
    <ExperienceContext.Provider value={cntx}>
      {children}
    </ExperienceContext.Provider>
  );
};

ExperienceProvider.propTypes = {
  value: PropTypes.shape([
    PropTypes.any,
    PropTypes.node
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  disableLocalization: PropTypes.bool
};

ExperienceProvider.defaultProps = {
  value: null,
  children: null,
  disableLocalization: false
};

export default ExperienceProvider;
